module.exports = __webpack_public_path__ + "img/ic-clock.0db477e8.svg";